import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import installActions from '../actions/install';
import CheckCode from '../components/Install/CheckCode';
import { Container, Row, Col } from '../../legacy/hui/src/styled';
import { TitleBar } from '../components/TitleBar';
import { JumbotronHero } from '../components/Install/JumbotronHero';

const mapStateToProps = state => ({
  install: state.install
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...installActions }, dispatch)
});

class Install extends Component {
  static propTypes = {
    install: PropTypes.object,
    actions: PropTypes.object
  };

  componentDidMount() {
    this.props.actions.backToFirstScreen();
  }

  render() {
    const { install, actions } = this.props;
    const { submitInstallForm, backToFirstScreen, continueToEnquire } = actions;

    return (
      <React.Fragment>
        <TitleBar pageTitle={'Installation Service'} />
        <JumbotronHero />
        <Container>
          <Row>
            <Col xs={12}>
              <CheckCode
                install={install}
                onSubmit={submitInstallForm}
                backToFirstScreen={backToFirstScreen}
                continueToEnquire={continueToEnquire}
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Install);
